import { PriceBreakdown } from './Order'
import { Proteins } from './Pet'

export const hasWeightLimit = (product: ProductVariant) => product.needsMinimumWeightToPurchase

export enum ProductTypes {
  PATTIES = 'PATTIES',
  BONES = 'BONES',
  TREATS = 'TREATS',
  MEAL_PLANS = 'MEAL_PLANS',
  GIFT = 'GIFT',
  FREEZE_DRIED = 'FREEZE_DRIED',
}

export enum RawFeedingProductType {
  FROZEN = 'FROZEN',
  FREEZE_DRIED = 'FREEZE_DRIED',
}

export enum PouchSize {
  SIX_OUNCES = 6,
  SIXTEEN_OUNCES = 16,
  TWENTY_FIVE_OUNCES = 25,
}

export type TranslatedDescriptions = {
  enUS: string
  esES: string
}

export type Product = {
  productId: string
  name: string
  description?: string
  type: string
  slug: string
  status: string
}

export type ProductVariant = {
  productVariantId: string
  productId: string
  name: string
  label?: string
  slug: string
  description: string
  needsMinimumWeightToPurchase: boolean
  unitWeight?: number
  price: PriceBreakdown
  proteins: Proteins[]
  weight: number
  type: ProductTypes
  image: string
}

export type ProductVariantSnapshot = {
  productVariantId: string
  productId: string
  addOnExpiresAt?: string
  isAddOn: boolean
  name: string
  price: number
  quantity: number
  weight: number
  slug: string
  type: ProductTypes
}

type AnalysisPercentages = {
  minRawProtein: number
  minRawFat: number
  maxRawFiber: number
  maxMoisture: number
}

export type ProductVariantDetail = Omit<ProductVariant, 'description'> & {
  description: TranslatedDescriptions
  recurringPrice?: PriceBreakdown
  details: TranslatedDescriptions[]
  ingredients: { [k in Proteins]?: TranslatedDescriptions[] }
  analysisPercentages: { [k in Proteins]?: AnalysisPercentages }
  kilocaloriesPerOunces: { [k in Proteins]?: number }
  guidelines: TranslatedDescriptions[]
}

export type ShoppingCartItem = ProductVariant & {
  quantity: number
  isSubscribable: boolean
}

export type ShoppingCart = {
  clientId: string
  items: ShoppingCartItem[]
  priceBreakdown: PriceBreakdown
}
